import { render, staticRenderFns } from "./DailyAttendanceReport.vue?vue&type=template&id=56281fa9&scoped=true"
import script from "./DailyAttendanceReport.vue?vue&type=script&lang=js"
export * from "./DailyAttendanceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56281fa9",
  null
  
)

export default component.exports